<template>
  <div class="Management">
    <div class="top">
      <!-- <div class="action" @click="onCreate">
        <p>Create User</p>
        <i class="el-icon-circle-plus"></i>
      </div> -->
      <el-Input style="width: 300px;margin: 40px 40px 0;" placeholder="search by username or id" v-model="search"></el-Input>
      <el-button @click="getList" type="primary">Search</el-button>
    </div>

    <BackendList :list="user_list" @update="onUpdate"  @edit="onCreate"></BackendList>
    <el-pagination
      style="margin-left: 300px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>
    <el-dialog
        title="Create User"
        custom-class="popup_user"
        :visible.sync="dialog_visible"
        width="30%">
      <BackendCreate v-if="dialog_visible" :uid="edit_uid" @update="onUpdate"></BackendCreate>
    </el-dialog>
  </div>
</template>

<script>
  import BackendList from "@/components/Users/BackendList/BackendList";
  import BackendCreate from "@/components/Users/BackendCreate/BackendCreate";
  import {getUser} from "@/utils/api";

  export default {
    props: {},
    components:{
      BackendList,
      BackendCreate
    },
    data: () => {
      return {
        dialog_visible:false,
        user_list:[],
        search:'',
        edit_uid: '',
        edit_udata: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        }
      }
    },
    methods: {
      handleSizeChange(e) {
        this.pagination.size = e
        this.pagination.page = 1
        this.$nextTick(() => {
          this.getList()
        })
      },
      handleCurrentChange(e) {
        this.pagination.page = e
        this.$nextTick(() => {
          this.getList()
        })
      },
      onUpdate(){
        this.dialog_visible = false;
        this.getList()
      },
      onCreate(id){
        this.edit_uid = id
        this.dialog_visible = true
      },
      getList() {
        getUser({
          search: this.search,
          page: this.pagination.page,
          size: this.pagination.size,
        }).then(res => {
          this.user_list = res.user_list
          this.pagination.total = res.total
          this.pagination.page = res.page
          this.pagination.size = res.size
        })
      },
    },
    beforeMount(){
      this.getList()
    },
  };

</script>

<style lang="scss">
  @import "_Users.scss";
</style>